import React from 'react';
import PropTypes from 'prop-types';

import WidgetFrame from '../../Utils/Widget/Frame/Frame.jsx';
import WidgetTitle, { ALIGN } from '../../Utils/Widget/Title/Title.jsx';
import PriceHistoryWidgetRange from './Range/Range.jsx';
import Button from '../../Button/Button.jsx';
import PriceHistoryWidgetChart from './Chart/Chart.jsx';
import { DesktopAndTablet, Mobile } from '../../Utils/MediaComponents/MediaComponents.tsx';
import PriceHistoryMobileDetailedChart from '../Mobile/Detailed/Chart/Chart.jsx';

import realEstateTypeConfig from './realEstateTypeConfig.js';
import tracking from '../../../tracking/tracking.js';
import { getCommercializationType } from '../../../realEstateTypes.js';
import { NO_DATA_TEXT } from '../../../utils/globals.js';
import { svgWidgetMobileMargins, ticksConfigWidgetMobile } from './config.js';
import { DASHBOARD_BUTTON_PRICE_DEV } from '../../../tracking/trackingNaming.js';

import styles from '../PriceHistory.less';
import getToAndFromPrice from '../../../utils/priceStatCalculator.js';

export default class PriceHistoryWidget extends React.Component {
  renderRange(fromPrice, toPrice, commercializationType) {
    return (
      <div className={`grid-item one-whole align-left ${styles.responsivePadding}`}>
        <PriceHistoryWidgetRange from={fromPrice} to={toPrice} commercializationType={commercializationType} />
      </div>
    );
  }

  render() {
    const { pricesPerQ, pricesPerYear, realEstateType, address, onButtonClicked, hierarchyLevel } = this.props;
    const config = realEstateTypeConfig.getFor(realEstateType, hierarchyLevel);

    // TODO find a proper way to display if no data
    const noData = !pricesPerQ;
    if (noData) {
      return (
        <WidgetFrame>
          <div className={`grid grid-flex grid-justify-space-between ${styles.widgetContainer}`}>
            <div className="grid-item one-whole align-center">
              <WidgetTitle
                id="price-history"
                align={ALIGN.center}
                text={config.title({ address })}
                subText={config.subTitle({ address })}
                cosmaIcon="is24-icon-financing"
              />
            </div>
            <div className="grid-item one-whole align-center padding-vertical-xl padding-horizontal-xxl">
              {NO_DATA_TEXT}
            </div>
          </div>
        </WidgetFrame>
      );
    }

    const { toPrice, fromPrice } = getToAndFromPrice(pricesPerQ);

    const commercializationType = getCommercializationType(realEstateType);
    const renderRange = this.renderRange;

    return (
      <WidgetFrame>
        <div className={`grid grid-flex grid-justify-space-between ${styles.widgetContainer}`}>
          <div className="grid-item one-whole align-center">
            <WidgetTitle
              id="price-history"
              align={ALIGN.center}
              text={config.title({ address })}
              subText={config.subTitle({ address })}
              cosmaIcon="is24-icon-financing"
            />
          </div>
          <DesktopAndTablet
            render={() => (
              <>
                {renderRange(fromPrice, toPrice, commercializationType)}
                <div className={`grid-item one-whole ${styles.widget}`} id="price-history-chart">
                  <PriceHistoryWidgetChart
                    priceHistory={pricesPerYear}
                    svgHeight={220}
                    commercializationType={commercializationType}
                  />
                </div>
              </>
            )}
          />
          <Mobile
            render={() => (
              <>
                <div className={`grid-item one-whole ${styles.widget}`} id="price-history-chart-mobile">
                  <PriceHistoryMobileDetailedChart
                    nativeData={pricesPerYear}
                    parentData={[]}
                    xOrient="bottom"
                    margins={svgWidgetMobileMargins}
                    ticksConfig={ticksConfigWidgetMobile}
                    updateSelected={() => {}}
                    showGridLines
                    showMarker={false}
                    newDesignGraph={false}
                  />
                </div>
                {renderRange(fromPrice, toPrice, commercializationType)}
              </>
            )}
          />
          <div className="grid-item one-whole align-right margin-top-m">
            <Button
              text="Entwicklung ansehen"
              cosmaButtonClass="button-primary"
              onClickHandler={() => {
                tracking.report(DASHBOARD_BUTTON_PRICE_DEV);
                onButtonClicked && onButtonClicked();
              }}
            />
          </div>
        </div>
      </WidgetFrame>
    );
  }
}

const priceShape = PropTypes.shape({
  year: PropTypes.number.isRequired,
  quarter: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
});

PriceHistoryWidget.defaultProps = {
  pricesPerQ: null,
  address: null,
  onButtonClicked: () => {},
  hierarchyLevel: null,
};

PriceHistoryWidget.propTypes = {
  pricesPerQ: PropTypes.arrayOf(priceShape),
  address: PropTypes.string,
  onButtonClicked: PropTypes.func,
  realEstateType: PropTypes.string.isRequired,
  hierarchyLevel: PropTypes.string,
};
